// REF: https://github.com/cape-io/hash-code-string
import { toBase64 } from './';

const hashCode = (str: string): number => [...str].reduce((s, c) => Math.imul(31, s) + c.charCodeAt(0) | 0, 0);
const num32toBytes = (num: number): Uint8Array => new Uint8Array([0, 8, 16, 24].map((x) => num >> x));
const codesToString = (bytes: Uint8Array): string => String.fromCharCode(...bytes);
const encode64 = (str: string): string => toBase64(str).replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');

export function getPseudoHash(str: string): string {
    return encode64(codesToString(num32toBytes(hashCode(str))));
}
